export default "__VITE_ASSET__BHk_Tw5w__"